<style lang="scss" scoped>
    header {
      height: 40px;
      font-size: 12px;
      line-height: 40px;
      text-align: right;
      position: relative;
      width: 1280px;
      margin: 0 auto;
    }
    .language{
      cursor: pointer;
      &.active{
      color: #114c9a;
      }
    }
    .login-btn {
      cursor: pointer;
    }
    .tips{
      position: absolute;
      right: 0;
      border: 1px solid red;
      z-index: 500;
      width: 100px;
      line-height: 30px;
      font-size: 12px;
      color: #666666;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      text-align: center;
      top: 45px;
      div:hover{
        background: #666666;
        color: #ffffff;
        cursor: pointer;
      }
      .item{
        border-bottom: 1px solid #e6e6e6;
      }
      &:after{
        content: '';
        display: block;
        border: 5px solid #ffffff;
        border-top-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        position: absolute;
        left: 50%;
        margin-left: -5px;
        top: -10px;
      }
    }
    .arrow:after{
      content: '';
      display: inline-block;
      border: 5px solid #e6e6e6;
      border-left-color: transparent;
      border-top-color: transparent;
      border-right-color: transparent;
      vertical-align: text-top;
    }
    .arrow-bottom:after{
      content: '';
      display: inline-block;
      border: 5px solid #e6e6e6;
      border-left-color: transparent;
      border-bottom-color: transparent;
      border-right-color: transparent;
      vertical-align: middle;
    }
</style>
<template>
  <header>
      <p style="width: 1280px;margin: 0 auto;">
        <span v-if="englishpc==1" @click="changeLaguage('en')" class="language" :class="{active: language==='en' ? true: false}" style="padding-right: 20px;border-right: 1px solid #E6E6E6;">English</span>
        <span class="language" @click="changeLaguage('ch')" :class="{active: language==='ch' ? true: false}" style="margin-left: 20px;margin-right: 50px;">简体中文</span>
        <span class="login-btn" @click.stop="toggle">
          <img src="../tpl3/images/login.png" style="vertical-align: middle;margin-right: 5px;" alt="">
          <span @click.stop="login" v-show="!isLogin">{{ $t("message.tpl3.menu.login") }}</span>
          <span v-show="isLogin" v-if="user!=null">{{user.uName}}</span>
        <!-- <span @click.stop="logout" v-show="isLogin">{{ $t("message.tpl3.menu.logout") }}</span> -->
        </span>
        <span style="margin-left: 5px;" :class="{'arrow-bottom': isLogin, arrow: !isLogin}"></span>
      </p>
      <div v-show="showTips" class="tips">
        <div v-if="isLogin&&isregister==1" class="item" @click="doReg">
          {{ $t("message.tpl1.menu.info") }}
        </div>
        <div @click.stop="logout">
          <span  v-show="isLogin">{{ $t("message.tpl3.menu.logout") }}</span>
        </div>
      </div>
    </header>
</template>
<script>
 let msg = {
    ch: {
      logOutSuccess: '退出成功!'
    },
    en: {
      logOutSuccess: 'successfully logged out'
    }
  }
export default {
  data(){
    return {
      language: 'cn',
      isLogin: false,
      user: null,
      showTips: false
    }
  },
  props:{
    baseInfo: {
      type: Object
    },
    englishpc:{
      type: Number
    },
    isregister:{
      type:String
    }
  },
  methods:{
    doReg(){
      window.open(location.origin + '/tpl/sign/add/0')
    },
    toggle(){
      // login()
      this.showTips = !this.showTips
    },
    changeLaguage(lang){
      localStorage.setItem('locale', lang)
      setTimeout(()=>{
        location.reload()
      }, 20)
    },
    login(path){
      this.checkLogin()
    },
    logout(){
      this.showTips = false;
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('uid');
        localStorage.clear();
        sessionStorage.clear();
      let locale = window.navigator.language||window.navigator.browserLanguage;
      if (locale != 'zh-CN') {
        locale = "en";
      } else {
        locale = 'ch';
      }
      localStorage.setItem('locale', locale);
        this.isLogin = false;
        this.user = {};
        this.$Message.info(msg[this.language].logOutSuccess);
        return;
      },
    checkLogin(){
      let token = localStorage.getItem('token');
      let uid = localStorage.getItem('uid');
      if (uid == null || !uid) {
//            跳转到登录页面
         if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
                window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
              }
              let origin = window.location.origin;
            const back = encodeURIComponent(location.href);
        location.href = origin+`/login?back=${back}&cid=${this.$route.params.cid}`;
//          this.showBox = true;
        return false;
      }
      return true;
    }
  },
  mounted(){
    this.language = localStorage.getItem('locale');
    let token = localStorage.getItem('token');
    if (token) {
      this.isLogin = true;
      this.user = JSON.parse(localStorage.getItem('user'));
    }
    window.addEventListener('click', e=>{
      let classname = e.target.className.toLowerCase();
        if (classname.indexOf('tips') === -1) {
          this.showTips = false;
        } else {
          this.showTips = true;
        }
    })
  },

}
</script>



// WEBPACK FOOTER //
// headerTop.vue?20c722da